module.exports = __webpack_public_path__ + "static/media/product-logo-1.5df7233d.svg";